import { render, staticRenderFns } from "./PgaOfferEvaluationTotalAmountsDetails.vue?vue&type=template&id=51d8dd08&"
import script from "./PgaOfferEvaluationTotalAmountsDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationTotalAmountsDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51d8dd08')) {
      api.createRecord('51d8dd08', component.options)
    } else {
      api.reload('51d8dd08', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationTotalAmountsDetails.vue?vue&type=template&id=51d8dd08&", function () {
      api.rerender('51d8dd08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/details/sub-components/PgaOfferEvaluationTotalAmountsDetails.vue"
export default component.exports